import { CssBaseline } from '@mui/material'
import {
  StyledEngineProvider,
  ThemeProvider as MuiThemeProvider,
} from '@mui/material/styles'
import type { FC, ReactNode } from 'react'
import { ThemeProvider as StyledThemeProvider } from 'styled-components'

import theme from './theme'

type Props = {
  children: ReactNode
}

const ThemeProviders: FC<Props> = ({ children }) => (
  <StyledEngineProvider injectFirst>
    <MuiThemeProvider theme={theme}>
      <StyledThemeProvider theme={theme}>
        <CssBaseline />
        {children}
      </StyledThemeProvider>
    </MuiThemeProvider>
  </StyledEngineProvider>
)

export default ThemeProviders
